import { render, staticRenderFns } from "./CondutaColaborador.vue?vue&type=template&id=a8050d6c&scoped=true"
import script from "./CondutaColaborador.vue?vue&type=script&lang=js"
export * from "./CondutaColaborador.vue?vue&type=script&lang=js"
import style0 from "./CondutaColaborador.vue?vue&type=style&index=0&id=a8050d6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8050d6c",
  null
  
)

export default component.exports